import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Icon, TextSimpleAutocomplete, AbstractFormComponent} from 'front-onceforall-core';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {requiredValidator} from 'front-onceforall-core/dist/utils/validators';
import documentTypeService from '../../../services/documentType/DocumentTypeService';
import documentService from '../../../services/document/DocumentService';
import * as snackbarsActions from '../../../actions/snackbars';
import {captureError} from '../../../utils/log';

export class AddDocumentForm extends AbstractFormComponent {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      suggestions: []
    };
  }

  componentDidMount() {
    documentTypeService.getDocumentAddableForOrganisation(this.props.organisation.organisationId, this.props.dossierCountry)
      .then(results => {
        const suggestions = results.map(documentType => ({label: documentType.name, value: documentType}));

        this.setState({suggestions});
      })
      .catch(error => {
        captureError('Error while retrieving addable document type', error);
        this.props.actions.addError(<Translate value="error.generic"/>);
      })
      .finally(() => {
        this.setState({loading: false});
      });
  }

  getFormData() {
    return {
      documentType: null
    };
  }

  getFormValidators() {
    return {
      documentType: requiredValidator
    };
  }

  handleSubmitCallback() {
    documentService.addDocument(this.props.organisation.organisationId, this.state.formData.documentType.value)
      .then(() => {
        this.props.actions.addSuccess(<Translate value="dossier.addSuccessful"/>);
        this.props.onSuccess();
      })
      .catch(error => {
        captureError('Error while adding document', error);
        this.props.actions.addError(<Translate value="error.generic"/>);
        this.props.onCancel();
      });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        {this.state.loading && <div className="loading-overlay"/>}
        <h2><Translate value="dossier.add"/></h2>

        <TextSimpleAutocomplete
          label={this.getFieldLabel('dossier.addLabel')}
          onChange={this.handleChange('documentType')}
          error={this.isOnError('documentType')}
          helperText={this.helperText('documentType')}
          value={this.state.formData.documentType}
          suggestions={this.state.suggestions}
          minimumCharsToRenderResults={0}
          maxResult={5}
        />

        <div className="actions col-12 flex-container space-between">
          <button
            type="button"
            className="large secondary flex-container"
            onClick={this.props.onCancel}
            data-id="cancel"
          >
            <Icon icon="go-back"/>
            <Translate value="action.cancel"/>
          </button>
          <button
            className="large primary flex-container"
            type="submit"
            disabled={this.state.submitting}
          >
            <Icon icon={this.state.submitting ? 'loader' : 'check'}/>
            <Translate value="action.confirm"/>
          </button>
        </div>
      </form>
    );
  }
}

AddDocumentForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  organisation: PropTypes.object.isRequired,
  dossierCountry: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...snackbarsActions}, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(AddDocumentForm);
